// removed by extract-text-webpack-plugin
module.exports = {"container":"_3jYjJ0cpdQ1H7FP9bo0DmZ","contentView":"CHHmXsaiQQTdQT0J5ZSFT","addCardView":"_1pYhqaL1VbkD2XaXTPGQBf","img":"_1SO_i8Cn4ehlkE1mkkZIDB","title":"_13Gcny5zZn3q4Uudp5XXX8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Payment/PaymentList.scss
// module id = 1149
// module chunks = 0